const PHONE_DIGITS_LENGTH = 11;

export const PHONE_REGEX = /^\(\d{2}\) \d{5}-\d{4}$/;

export const formatMobilePhoneWithDDD = (value = "") => {
  const digits = String(value).replace(/\D/g, "").slice(0, PHONE_DIGITS_LENGTH);

  if (!digits) {
    return "";
  }

  if (digits.length <= 2) {
    return `(${digits}`;
  }

  if (digits.length <= 7) {
    return `(${digits.slice(0, 2)}) ${digits.slice(2)}`;
  }

  return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7, 11)}`;
};

export const isValidMobilePhoneWithDDD = (value = "") =>
  PHONE_REGEX.test(String(value).trim());
